module.exports = __webpack_public_path__ + "img/IMG_20200717_223640.689d7ef7.jpg";